import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerSharedActivityResolver } from '~/organizer/shared/resolvers/activity/activity.resolver';
import { OrganizerActivityEditionAddressComponent } from './components/pages/address/address.component';
import { OrganizerActivityEditionAudienceComponent } from './components/pages/audience/audience.component';
import { OrganizerActivityEditionDescriptionComponent } from './components/pages/description/description.component';
import { OrganizerActivityEditionDurationComponent } from './components/pages/duration/duration.component';
import { OrganizerActivityEditionComponent } from './components/pages/edition/edition.component';
import { OrganizerActivityEditionEquipmentComponent } from './components/pages/equipment/equipment.component';
import { OrganizerActivityEditionPhotoComponent } from './components/pages/photo/photo.component';
import { OrganizerActivityEditionSportComponent } from './components/pages/sport/sport.component';
import { OrganizerActivityEditionTitleComponent } from './components/pages/title/title.component';
import { OrganizerActivityEditionUploadsComponent } from './components/pages/uploads/uploads.component';
import { OrganizerActivityEditionFormuleComponent } from './components/pages/formule/formule.component';

const routes: Routes = [
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition',
    component: OrganizerActivityEditionComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.sport',
    component: OrganizerActivityEditionSportComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.title',
    component: OrganizerActivityEditionTitleComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.photo',
    component: OrganizerActivityEditionPhotoComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.equipment-provided',
    component: OrganizerActivityEditionEquipmentComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.equipment-required',
    component: OrganizerActivityEditionEquipmentComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.description',
    component: OrganizerActivityEditionDescriptionComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.duration',
    component: OrganizerActivityEditionDurationComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.address',
    component: OrganizerActivityEditionAddressComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.audience',
    component: OrganizerActivityEditionAudienceComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.uploads',
    component: OrganizerActivityEditionUploadsComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity-edition.edition/organizer.activity-edition.formules/:slug',
    component: OrganizerActivityEditionFormuleComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerActivityEditionRoutingModule {}
